import { Converter } from '../utils/converter'

export default {
  name: 'cart-converter',

  ui: {
    select: '[js-converter-select]',
    total: '[js-converter-total]',
    currency_total: '[js-converter-currency-total]',
    currency_symbol: '[js-converter-currency-symbol]',
  },

  events: [
    {
      target: 'select',
      on: 'change',
      handle (e) {
        Converter.convert(e.currentTarget, this.ui.currency_total, this.ui.currency_symbol, this.ui.total.value)
      },
    },
  ],
}
